import React, { createContext, FC, useContext } from 'react'

const GridIdentityContext = createContext('')

export const GridIdentityProvider: FC<{ identity: string }> = ({ identity, children }) => {
  return <GridIdentityContext.Provider value={identity}>{children}</GridIdentityContext.Provider>
}

export const useGridIdentity = () => useContext(GridIdentityContext)
